import React from "react";
import "./GetMusicOnKKBOX.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnKKBOX = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select KKBOX Distribution",
    "Music delivered across Asia",
    "Reach millions of listeners",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>KKBOX Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music to KKBOX streaming platform across Asia with FT Tunes and reach millions of music fans."
        />

        <meta
          name="keywords"
          content="KKBOX music distribution, distribute music KKBOX, KKBOX streaming platform"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="kkbox-page">

        {/* HERO */}
        <section className="kkbox-hero">
          <Container>

            <img
              src="/Images/kkbox-logo.png"
              alt="KKBOX"
              className="kkbox-logo"
            />

            <h1>Distribute Your Music on KKBOX</h1>

            <p>
              Reach millions of listeners across Taiwan, Japan,
              Hong Kong, Singapore and Asia’s leading music
              streaming platform with KKBOX distribution.
            </p>

            <Button
              className="gradient-btn-kkbox"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-kkbox"></div>
        </section>


        {/* SHOWCASE */}
        <section className="kkbox-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Grow Your Fanbase in Asia</h2>

                <p>
                  KKBOX is one of Asia’s top music platforms.
                  Get discovered by dedicated listeners and expand
                  your reach into powerful music markets.
                </p>

                <Button
                  className="outline-btn-kkbox"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-kkbox.png"
                  alt="get your music on kkbox"
                  className="kkbox-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="kkbox-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-kkbox">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="kkbox-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on KKBOX
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-kkbox">
                  <h5>Asian Market Reach</h5>
                  <p>Strong presence across Asia.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-kkbox">
                  <h5>Active Music Community</h5>
                  <p>Highly engaged listeners.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-kkbox">
                  <h5>Artist Analytics</h5>
                  <p>Track listener performance.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-kkbox">
                  <h5>Global Revenue</h5>
                  <p>Earn from international streams.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="kkbox-cta">
          <Container>

            <h2>Start Your KKBOX Music Distribution Today</h2>

            <Button
              className="gradient-btn-kkbox big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnKKBOX;